import useTranslation from 'next-translate/useTranslation';
import { createStyles } from '@mantine/core';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import Container from '~/domains/design-system/Container';
import { Routes } from '~/domains/common/constants/routes';
import dt from '~/testing';

import {
  GamecenterScheduledNavListItem,
  GamecenterScheduledNavList,
} from './GamecenterScheduleNavComponents';

const useStyles = createStyles((theme) => ({
  container: {
    background: theme.colors.gray[9],
    borderTop: `1px solid ${theme.colors.gray[8]}`,
    overflow: 'auto',
  },
}));

function GamecenterScheduledNav({ contest }: { contest: FullContest }) {
  const { t } = useTranslation('contest');
  const { classes } = useStyles();
  const contestId = contest.id;
  const isSpectatorMode = contest?.public_viewing && contest?.entries.user === 0;

  return (
    <div className={classes.container}>
      <Container>
        <GamecenterScheduledNavList>
          {!isSpectatorMode ? (
            <GamecenterScheduledNavListItem
              href={Routes.gamecenterEntriesOverall(contestId)}
              data-test-id={dt.contest.gamecenter.common.navigation.scheduled.entries}
            >
              {t('gamecenter.layoutScheduled.nav.entries')}
            </GamecenterScheduledNavListItem>
          ) : null}
          <GamecenterScheduledNavListItem
            href={Routes.gamecenterEntrants(contestId)}
            data-test-id={dt.contest.gamecenter.common.navigation.scheduled.entrants}
          >
            {t('gamecenter.layoutScheduled.nav.entrants')}
          </GamecenterScheduledNavListItem>
          <GamecenterScheduledNavListItem
            href={Routes.contestDetail(contestId)}
            data-test-id={dt.contest.gamecenter.common.navigation.scheduled.detail}
          >
            {t('gamecenter.layoutScheduled.nav.detail')}
          </GamecenterScheduledNavListItem>
        </GamecenterScheduledNavList>
      </Container>
    </div>
  );
}

export default GamecenterScheduledNav;
